export const HELIOS_SUPPORTED_LANGUAGES = {
  en: 'en_US',
  bg: 'bg_BG',
  cs: 'cs_CZ',
  de: 'de_DE',
  el: 'el_GR',
  fr: 'fr_FR',
  ru: 'ru_RU',
  da: 'da_DK',
  nl: 'nl_NL',
  fi: 'fi_FI',
  hu: 'hu_HU',
  in: 'id_ID', //helios supported format
  it: 'it_IT',
  ja: 'ja_JP',
  ko: 'ko_KR',
  nb: 'no_NO', //helios supported format
  mn: 'mn_MN',
  pl: 'pl_PL',
  pt: 'pt_BR', //helios supported format
  ro: 'ro_RO',
  sv: 'sv_SE',
  sl: 'sl_SI',
  th: 'th_TH',
  tr: 'tr_TR',
  ar: 'en_US', //helios supported format
  es: 'es_ES', //helios supported format changed from es_MX to es_ES
  'zh-CN': 'zh_CN',
  'zh-TW': 'zh_TW' //helios supported format changed to zh_TW
};

export const LOCALES_NEEDING_TRANSFORMATION = [
  'ar_EG',
  'he_IL',
  'bn_BD',
  'cs_CZ',
  'da_DK',
  'in_ID',
  'nb_NO',
  'th_TH'
];

export const LOCALE_ALTERNATIVE_CODES = {
  NB_NO: 'nb_NO',
  IN_ID: 'in_ID',
  NO: 'no',
  ID: 'id'
};

export const BLOB = 'blob';

export const CAT_SIGN_IN = 'signin.cat.com';
export const COOKIE_LOGON_USER_ID = 'WC_LogonUserId';
export const COOKIE_B2C_CHECK_SSO = 'cat-b2c-checksso';
export const CAT_DOMAIN = 'cat.com';
export const PROTOCOL = 'https://';
export const HOSTED_TRANSLATION_PATH =
  '/SETUP/assets/TranslationTool/JSON/ReactResourceBundle';
export const HOSTED_TRANSLATION_PATH_BFF =
  '/SETUP/assets/TranslationTool/JSON/CommerceResourceBundle';

export const SESSION_ID = 'JSESSIONID';

export const SAME_DOMAIN_COOKIES = [SESSION_ID];
